
import Banner from '../banner/banner';
import WhyChoose from '../whyChoose/whyChoose';
import Comparison from '../comparison/comparison';
import Testimonial from '../testimonial/testimonial';
import Faq from '../faq/faq';
import CourseList from '../course/courseList';

function HomePage() {
    return (
        <div className="App">
            <Banner />
            <WhyChoose />
            <Comparison />
            <Testimonial />
            <Faq />
            <CourseList />
            {/* <Contact /> */}
            
        </div>
    );
}

export default HomePage;
